var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 24.7303 61.5759 18.0269 57.4919 12.6538C51.6474 4.96457 42.4035 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM44.175 22.8419C45.0082 22.0087 45.0082 20.658 44.175 19.8249C43.3419 18.9918 41.9912 18.9918 41.158 19.8249L31.9999 28.983L22.8417 19.8249C22.0086 18.9918 20.6578 18.9918 19.8247 19.8249C18.9916 20.658 18.9916 22.0087 19.8247 22.8419L28.9829 32L19.8247 41.1582C18.9916 41.9913 18.9916 43.3421 19.8247 44.1752C20.6578 45.0083 22.0086 45.0083 22.8417 44.1752L31.9999 35.017L41.158 44.1752C41.9912 45.0083 43.3419 45.0083 44.175 44.1752C45.0082 43.3421 45.0082 41.9913 44.175 41.1582L35.0169 32L44.175 22.8419Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.f3be14d41c10f67b492abd51481fce32.svg";
export { ForwardRef as ReactComponent };